import { FollowerType } from "./../../../../../types";
import { Moment } from "moment";
import moment from "moment";
import "./follower-matrix.scss";
import { useEffect, useState } from "react";

function FollowerMatrix({ data, streamIds, dateFrom, dateTo }: { data: FollowerType[]; streamIds: number[]; dateFrom: Moment; dateTo: Moment }) {
    const [weeks, setWeeks] = useState<string[]>([]);
    const [dates, setDates] = useState<Moment[]>([]);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const getStream = (stream: number) => {
        return (
            {
                7: "X",
                8: "Facebook",
                9: "Instagram",
                10: "Youtube",
                11: "Linkedin",
            }[stream] || ""
        );
    };

    function getTotalFollowers(stream: number, date: Moment) {
        var followerCount = 0;
        var d = moment(date);

        if (data.length > 0) {
            if (stream === 0) {
                var values = [];

                for (var stream of streamIds) {
                    values.push(
                        data.filter((x) => x.StreamId === stream && (moment(x.DateCaptured).isBetween(moment(date), moment(date).add(6, "d")) || moment(x.DateCaptured).isSame(moment(d).set("h", 0).set("m", 0).set("s", 0).set("ms", 0))))
                    );
                }

                for (var i = 0; i < values.length; i++) {
                    if (values[i][0]) {
                        followerCount += values[i][0].FollowerCount;
                    }
                }

                if (followerCount === 0) {
                    return "-";
                } else {
                    return followerCount;
                }
            } else {
                var dt = data.filter((x) => x.StreamId === stream && (moment(x.DateCaptured).isBetween(moment(date), moment(date).add(6, "d")) || moment(x.DateCaptured).isSame(moment(d).set("h", 0).set("m", 0).set("s", 0).set("ms", 0))));
                if (dt[0]) {
                    followerCount += dt[0].FollowerCount;
                }

                if (followerCount === 0) {
                    return "-";
                } else {
                    return followerCount;
                }
            }
        }
    }

    function getGrowth(stream: number, date: Moment) {
        var currentValues = [];
        var pastValues = [];
        if (data.length > 0) {
            if (stream === 0) {
                var currentTotal = 0;
                var pastTotal = 0;

                for (var item of streamIds) {
                    var d = moment(date);
                    var pastD = moment(date).subtract(7, "d");
                    currentValues.push(
                        data.filter((x) => x.StreamId === item && (moment(x.DateCaptured).isBetween(moment(date), moment(date).add(6, "d")) || moment(x.DateCaptured).isSame(moment(d).set("h", 0).set("m", 0).set("s", 0).set("ms", 0))))
                    );
                    pastValues.push(
                        data.filter((x) => x.StreamId === item && (moment(x.DateCaptured).isBetween(moment(d).subtract(7, "d"), moment(date)) || moment(x.DateCaptured).isSame(moment(pastD).set("h", 0).set("m", 0).set("s", 0).set("ms", 0))))
                    );
                }

                for (let i = 0; i < currentValues.length; i++) {
                    if (currentValues[i][0]) {
                        currentTotal += currentValues[i][0].FollowerCount;
                    }
                }

                for (let i = 0; i < pastValues.length; i++) {
                    if (pastValues[i][0]) {
                        pastTotal += pastValues[i][0].FollowerCount;
                    }
                }

                if (currentTotal && pastTotal) {
                    if (currentTotal < pastTotal) {
                        return "- " + Math.abs(currentTotal - pastTotal);
                    } else if (currentTotal > pastTotal) {
                        return "+ " + Math.abs(currentTotal - pastTotal);
                    } else {
                        return "0";
                    }
                }
            } else {
                var d = moment(date);
                var pastD = moment(date).subtract(7, "d");
                var current = data.filter(
                    (x) => x.StreamId === stream && (moment(x.DateCaptured).isBetween(moment(date), moment(date).add(6, "d")) || moment(x.DateCaptured).isSame(moment(d).set("h", 0).set("m", 0).set("s", 0).set("ms", 0)))
                );
                var past = data.filter(
                    (x) => x.StreamId === stream && (moment(x.DateCaptured).isBetween(moment(d).subtract(7, "d"), moment(date)) || moment(x.DateCaptured).isSame(moment(pastD).set("h", 0).set("m", 0).set("s", 0).set("ms", 0)))
                );

                if (past[0] && current[0]) {
                    if (current[0].FollowerCount < past[0].FollowerCount) {
                        return "- " + Math.abs(current[0].FollowerCount - past[0].FollowerCount);
                    } else if (current[0].FollowerCount > past[0].FollowerCount) {
                        return "+ " + Math.abs(current[0].FollowerCount - past[0].FollowerCount);
                    } else {
                        return "0";
                    }
                }
            }
        }
    }

    function getGrowthIcon(stream: number, date: Moment) {
        if (stream === 0) {
            var currentTotal = 0;
            var pastTotal = 0;
            var currentValues = [];
            var pastValues = [];
            if (data.length >= 0) {
                for (var item of streamIds) {
                    var d = moment(date);
                    var pastD = moment(date).subtract(7, "d");
                    currentValues.push(
                        data.filter((x) => x.StreamId === item && (moment(x.DateCaptured).isBetween(moment(date), moment(date).add(6, "d")) || moment(x.DateCaptured).isSame(moment(d).set("h", 0).set("m", 0).set("s", 0).set("ms", 0))))
                    );
                    pastValues.push(
                        data.filter((x) => x.StreamId === item && (moment(x.DateCaptured).isBetween(moment(d).subtract(7, "d"), moment(date)) || moment(x.DateCaptured).isSame(moment(pastD).set("h", 0).set("m", 0).set("s", 0).set("ms", 0))))
                    );
                }

                for (let i = 0; i < currentValues.length; i++) {
                    if (currentValues[i][0]) {
                        currentTotal += currentValues[i][0].FollowerCount;
                    }
                }

                for (let i = 0; i < pastValues.length; i++) {
                    if (pastValues[i][0]) {
                        pastTotal += pastValues[i][0].FollowerCount;
                    }
                }

                if (currentTotal && pastTotal) {
                    if (currentTotal < pastTotal) {
                        return "fa-long-arrow-alt-down decrease";
                    } else if (currentTotal > pastTotal) {
                        return "fa-long-arrow-alt-up increase";
                    } else {
                        return "fa-equals no-change";
                    }
                }
            } else {
                var d = moment(date);
                var pastD = moment(date).subtract(7, "d");

                if (data.length >= 0) {
                    var current = data.filter(
                        (x) => x.StreamId === stream && (moment(x.DateCaptured).isBetween(moment(date), moment(date).add(6, "d")) || moment(x.DateCaptured).isSame(moment(d).set("h", 0).set("m", 0).set("s", 0).set("ms", 0)))
                    );
                    var past = data.filter(
                        (x) => x.StreamId === stream && (moment(x.DateCaptured).isBetween(moment(d).subtract(7, "d"), moment(date)) || moment(x.DateCaptured).isSame(moment(pastD).set("h", 0).set("m", 0).set("s", 0).set("ms", 0)))
                    );

                    if (past[0] && current[0]) {
                        if (current[0].FollowerCount < past[0].FollowerCount) {
                            return "fa-long-arrow-alt-down decrease";
                        } else if (current[0].FollowerCount > past[0].FollowerCount) {
                            return "fa-long-arrow-alt-up increase";
                        } else {
                            return "fa-equals no-change";
                        }
                    }
                }
            }
        }
    }

    useEffect(() => {
        var weekValues: string[] = [];
        var dateValues: Moment[] = [];

        console.log(dateTo);

        for (var i = moment(dateFrom).add(7, "d").isoWeekday(1); i.isSameOrBefore(moment(dateTo)); i.add(7, "d")) {
            let dtTo = i.clone().add(6, "d").isoWeekday(1);

            if (dtTo > moment()) {
                dtTo = moment();
            }

            weekValues.push(months[moment(dtTo).month()] + " Week " + dtTo.week());
            dateValues.push(moment(dtTo));
        }
        console.log(weekValues);
        setWeeks(weekValues);
        setDates(dateValues);
    }, [data]);

    return (
        <div className="follower-matrix component">
            <div className="top">
                <p>Follower Breakdown</p>
            </div>
            <div className="body">
                <table>
                    <thead>
                        <tr className="heading-fb">
                            <th colSpan={10}>Total Growth</th>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th>Stream</th>
                            {weeks.map((x: any, i: number) => {
                                return (
                                    <th className="week-value" key={i}>
                                        {weeks[i]}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {streamIds.length > 1 && (
                            <tr className="row-item">
                                <td>All</td>
                                {dates.map((y: Moment) => {
                                    return (
                                        <td className="right">
                                            {getTotalFollowers(0, y)}
                                            <td className="growth">
                                                <p>{getGrowth(0, y)}</p>
                                                <i className={`fas ${getGrowthIcon(0, y)}`}></i>
                                            </td>
                                        </td>
                                    );
                                })}
                            </tr>
                        )}
                        {streamIds.map((x: number) => {
                            return (
                                <tr className="row-item">
                                    <td>{getStream(x)}</td>
                                    {dates.map((y: Moment) => {
                                        return (
                                            <td className="right">
                                                {getTotalFollowers(x, y)}
                                                <td className="growth">
                                                    <p>{getGrowth(x, y)}</p>
                                                    <i className={`fas ${getGrowthIcon(x, y)}`}></i>
                                                </td>
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default FollowerMatrix;
